import { BusinessOutlined } from "@mui/icons-material";
import RffImportBorrowerEntitiesFromReduxButton from "../../components/finalForm/features/RffImportBorrowerEntitiesFromReduxButton";
import RffDateField from "../../components/finalForm/inputs/RffDateField";
import RffPercentField from "../../components/finalForm/inputs/RffPercentField";
import RffSelectAutocompleteField from "../../components/finalForm/inputs/RffSelectAutocompleteField";
import RffSelectField from "../../components/finalForm/inputs/RffSelectField";
import RffTextField from "../../components/finalForm/inputs/RffTextField";
import RffGroup from "../../components/finalForm/shared/RffGroup";
import { selectOptionsEntityType } from "../../constants/selectOptions/selectOptionsEntityType";
import { selectOptionsUsaStates } from "../../constants/selectOptions/selectOptionsUsaStates";
import TitledLoanSection from "./TitledLoanSection";

const BorrowingEntitiesSection = ({ testing }) => {
  return (
    <TitledLoanSection
      variant="h2"
      headerEndContent={<RffImportBorrowerEntitiesFromReduxButton />}
      icon={<BusinessOutlined className="thin" />}
      title="Borrowering Entities"
    >
      <RffGroup suppressBottomMargin>
        <RffTextField name="borrowerEntity.entityName" label="Entity Name" />
        <RffPercentField
          name="borrowerEntity.applicantEntityPercentOwnership"
          label="What percentage ownership of the entity does the borrower have?"
          // label="What percentage ownership of borrower entity do you own?"
        />
        <RffSelectAutocompleteField
          size={4}
          name="borrowerEntity.entityStateOfOrganization"
          label="Entity State Of Organization"
          options={selectOptionsUsaStates}
        />
        <RffSelectField
          name="borrowerEntity.entityType"
          size={4}
          label="Entity Type"
          options={selectOptionsEntityType}
        />
        <RffDateField
          size={4}
          name="borrowerEntity.entityOrganizationDate"
          label="Entity Organization Date"
        />
      </RffGroup>
      {/* <Divider sx={{ my: 5 }} />
      <RffGroup
        title="Upload Related Entity Documents"
        suppressBottomMargin
        headerSx={{ mb: 3 }}
        headerEndContent={
          <RffImportBorrowerDocumentsFromReduxButton
            docGroups={["Entity Docs"]}
          />
        }
        description="Upload any relevant documents pertaining to the entity."
        columnSpacing={5}
      >
        <RffFileUploadField
          size={6}
          label={"Articles of Organization"}
          docType={"Articles of Organization"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
        <RffFileUploadField
          size={6}
          label={"COGS"}
          docType={"COGS"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
        <RffFileUploadField
          size={6}
          label={"EIN"}
          docType={"EIN"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
        <RffFileUploadField
          size={6}
          label={"Operating Agreement"}
          docType={"Operating Agreement"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
      </RffGroup> */}
      {/* <Divider sx={{ my: 5 }} /> */}
    </TitledLoanSection>
  );
};

export default BorrowingEntitiesSection;
